export default __webpack_public_path__ + "static/media/Cairo-Regular.64b7f6f9.ttf";